import { appSettings } from 'src/settings/config';
import { Component, Input, OnInit } from '@angular/core';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { JobsService } from '../../../services/jobs.service';

@Component({
    standalone: false,
    selector: 'app-active-job-actions',
    templateUrl: './active-job-actions.component.html',
    styleUrls: ['./active-job-actions.component.scss']
})
export class ActiveJobActionsComponent implements OnInit {
    @Input()
    job: ITaskModel;
    showTaskTab: boolean = appSettings.showTaskTab;

    constructor(
        private readonly jobsService: JobsService,
    ) { }

    ngOnInit(): void {
    }

    jobMenuClick(event) {
        event.stopPropagation();
    }

    continueJob(event, job: ITaskModel) {
        this.jobsService.continueJob(job);
        event.stopPropagation();
    }

    stopJob(event, job: ITaskModel) {
        this.jobsService.stopJob(job);
        event.stopPropagation();
    }
}
